import React, { useEffect, useState } from 'react'
import { connect } from "react-redux"
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import Box from "@material-ui/core/Box"
import { CollateralStyles } from '../../CollateralStyles'
import { useTranslation } from 'react-i18next'
import { customStyleSecondary } from '../../../common/CommonStyles'
import DataTable from 'react-data-table-component'
import Container from '@material-ui/core/Container'
import Modal from 'antd/es/modal';
import { Backdrop, CircularProgress } from '@material-ui/core'

const Status = ({ classes, ...props }) => {
    const { t } = useTranslation()
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const { match: { params } } = props
    const paginationOptions = { rowsPerPageText: t('commonMessages.rowsPerPage'), rangeSeparatorText: t('common.to'), selectAllRowsItem: true, selectAllRowsItemText: t('common.all') }

    useEffect(() => {
        handleOpenBackdrop()
        props.actions.fetch_Invoices(props.userLanguage, props.userToken, params.woid, onError, onSuccess)
        return () => {

        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const onSuccess = () => {
        handleCloseBackdrop()
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 400:
                    Modal.error({
                        title: 'Error',
                        content: err.response.errors[0]
                    })
                    break
                case 500:
                    Modal.error({
                        title: 'Error',
                        content: t('commonMessages.alert500')
                    })
                    break
                default:
                    break
            }
        }
    }

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }

    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }

    const columns = [
        {
            name: t('collateralDetails.invoiceName'),
            selector: 'fileName',
            sortable: true,
            cell: row => row.fileName
        },
        {
            name: t('collateralDetails.registrationDate'),
            selector: 'collateralOrdInvDocInsertDt',
            width: '200px',
            sortable: true,
            cell: row => row.collateralOrdInvDocInsertDt
        },
        {
            name: t('collateralDetails.invoiceStatus'),
            selector: 'invoiceStatus',
            sortable: true,
            cell: row => row.invoiceStatus
        }
    ]

    return (
        <Container className={classes.generalBorder}>
            <Backdrop className={classes.backdrop} open={openBackdrop}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <br />
            <Typography component={'span'} variant="body1">{t('common.status')}:
                {
                    props.invoiceList && props.invoiceList.length > 1
                        ?
                        <Box fontWeight="fontWeightBold" display="inline"> {props.invoiceList[0].invoiceStatus}</Box>
                        :
                        <Box fontWeight="fontWeightBold" display="inline">{t('common.withoutInvoice')}</Box>
                }
            </Typography>
            <Grid item xs={12}><br /></Grid>
            <DataTable
                noHeader
                columns={columns}
                customStyles={customStyleSecondary}
                data={props.invoiceList}
                highlightOnHover
                defaultSortField="date"
                dense
                responsive
                striped
                pointerOnHover
                pagination
                paginationComponentOptions={paginationOptions}
                noDataComponent={<p className={classes.marginNoData}>{t('commonMessages.noData')}</p>}
            />
            {
                props.invoiceList && props.invoiceList.length < 1 && (
                    <Grid container item xs={12}><br /></Grid>
                )
            }
        </Container>
    )
}

const mapStateToProps = state => ({
    invoiceList: state.CollateralReducer.invoiceList,
    userProfile: state.UserProfileReducer.list,
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

export default connect(mapStateToProps)(withStyles(CollateralStyles)(Status))